/* eslint-disable */
import ViewerItem from "./ViewerItem";
import { Row, Col, Form, Button } from "react-bootstrap";
import { FormatComms } from "../ProblemForm/FormatComms";
import ModernViewer from "../Notes/ModernViewer";
import { intervalToDuration, formatDuration } from "date-fns";
// Generated by GitHub Copilot
import WorkflowHistoryViewer from "./WorkflowHistoryViewer";
import PagerDutyActivity from "../Modern/IncidentDetails/PagerDutyActivity";
// Generated by GitHub Copilot
import InterestedPartiesViewer from "./InterestedPartiesViewer";
// Generated by GitHub Copilot
import ImpactReportsViewer from "./ImpactReportsViewer";
import { hasEditorAccess } from "../../utils/privilegeHelpers";
import {
  hasIncidentLinkageContext,
  resolveIncidentDisplayWithPlaceholder,
} from "../../utils/incidentLinkage";

function SinglePane(props) {
  const outage = props.outage;
  const slackURL = props.slackURL;
  const problem = props.problem;
  const user = props.user;
  // Generated by GitHub Copilot - Trigger for refreshing impact list
  const impactRefreshTrigger = props.impactRefreshTrigger;

  const awsCase = outage && outage.awscase ? outage.awscase : "";

  const d = intervalToDuration({
    start: new Date(outage.incidentStartRaw ?? outage.incidentStart),
    end: new Date(outage.incidentEndRaw ?? outage.incidentEnd),
  });

  const duration = formatDuration(d, {
    format: ["months", "days", "hours", "minutes", "seconds"],
  });

  const width = 12;

  return (
    <>
      <ViewerItem
        title="Incident Status"
        id="status"
        value={outage && outage.status ? outage.status : ""}
        width={width}
      />
      {hasEditorAccess(user) &&
        problem &&
        (hasIncidentLinkageContext(
          problem.incidentNumber,
          problem.number,
        ) ||
          awsCase) && (
          <ViewerItem
            title="Incident Number"
            id="incidentNumber"
            value={resolveIncidentDisplayWithPlaceholder(
              problem.incidentNumber,
              problem.number,
              !!awsCase,
            )}
            width={width}
          />
        )}
      {hasEditorAccess(user) && problem && awsCase && (
        <ViewerItem
          title="AWS Case #"
          id="awscase"
          value={awsCase}
          width={width}
        />
      )}
      <ViewerItem
        id="nextUpdate"
        title="Next Update"
        value={outage ? outage.nextUpdate : ""}
        width={width}
      />
      <ViewerItem
        title="Current Status"
        id="currentStatus"
        value={
          outage && outage.currentStatus ? outage.currentStatus : "Loading..."
        }
        width={width}
      />

      <ViewerItem
        title="Incident Commander"
        id="incidentCommander"
        value={
          outage && outage.incidentCommander ? outage.incidentCommander : ""
        }
        width={width}
      />
      <ViewerItem
        title="Incident Manager"
        id="incidentManager"
        value={outage && outage.mim ? outage.mim : ""}
        width={width}
      />
      <ViewerItem
        title="Business Liaison"
        id="businessLiaison"
        value={outage.businessLiaison ? outage.businessLiaison : ""}
        width={width}
      />

      <ViewerItem
        title="Client Impact"
        id="clientImpact"
        value={outage && outage.impact ? outage.impact : ""}
        width={width}
      />
      <ViewerItem
        title="Workaround"
        value={outage && outage.workaround ? outage.workaround : ""}
        width={width}
      />
      <ViewerItem
        title="Affected Users"
        value={outage && outage.affectedUsers ? outage.affectedUsers : ""}
        width={width}
      />

      <ViewerItem
        title="Message for External Clients"
        value={
          outage && outage.messageForClients ? outage.messageForClients : ""
        }
        width={width}
      />
      <ViewerItem
        title="Number of Contacts"
        value={outage && outage.numberOfContacts ? outage.numberOfContacts : ""}
        width={width}
      />
      <ViewerItem
        title="Impact Begin"
        id="impactStart"
        value={outage && outage.incidentStart ? outage.incidentStart : ""}
        width={width}
      />
      <ViewerItem
        title="Impact End"
        id="impactEnd"
        value={outage && outage.incidentEnd ? outage.incidentEnd : ""}
        width={width}
      />
      <ViewerItem
        title="Impact Duration"
        id="impactDuration"
        value={duration}
        width={width}
      />
      <ViewerItem
        title="SalesForce Case #"
        value={outage && outage.salesForceCase ? outage.salesForceCase : ""}
        width={width}
      />

      <ViewerItem
        title="Technical Status"
        value={outage && outage.technicalStatus ? outage.technicalStatus : ""}
        width={width}
      />
      <ViewerItem
        title="Perceived Cause"
        value={outage && outage.perceivedCause ? outage.perceivedCause : ""}
        width={width}
      />
      <ViewerItem
        title="Current Approach"
        value={outage && outage.currentApproach ? outage.currentApproach : ""}
        width={width}
      />
      <ViewerItem
        title="Vendor Ticket"
        value={outage && outage.vendorTicket ? outage.vendorTicket : ""}
        width={width}
      />
      <ViewerItem
        title="AWS Account"
        value={outage && outage.awsAccount ? outage.awsAccount : ""}
        width={width}
      />
      <ViewerItem
        title="Time Detected"
        id="timeDetected"
        value={outage && outage.timeDetected ? outage.timeDetected : ""}
        width={width}
      />
      <ViewerItem
        title="Command Center Notified"
        id="EOCNotified"
        value={outage && outage.eocNotified ? outage.eocNotified : ""}
        width={width}
      />
      <ViewerItem
        title="Technical Time of Resolution"
        value={outage && outage.techTimeResolved ? outage.techTimeResolved : ""}
        width={width}
      />

      <ViewerItem
        title="Slack Channel"
        id="slackChannel"
        value={
          outage && outage.slackChannel ? (
            <a target="blank" href={slackURL}>
              {outage.slackChannel}
            </a>
          ) : (
            ""
          )
        }
        width={width}
      />

      {outage && outage.pagerDutyID ? (
        <Col xs={12} md={4} lg={3} xl={3}>
          <Row>
            <Col>
              {outage && outage.pagerDutyID ? (
                <a
                  href={
                    "https://coxauto.pagerduty.com/incidents/" +
                    outage.pagerDutyID +
                    "/timeline"
                  }
                  target="_blank"
                >
                  <Button variant="success">PagerDuty Timeline</Button>
                </a>
              ) : (
                "None"
              )}
            </Col>
          </Row>
        </Col>
      ) : (
        <></>
      )}

      {/* Generated by GitHub Copilot */}
      {/* Display impact reports when impact reporting is enabled */}
      {problem && problem.number && !problem.temporary && (
        <>
          <Row>
            <Col className="headings" xs={6} sm={6} md={6} lg={5} xl={5}>
              Impact Reports
            </Col>
          </Row>
          <Row>
            <Col className="priorityDescription">
              My Reports are highlighted in blue and listed first
            </Col>
          </Row>
          <Row>
            <Col>
              <ImpactReportsViewer
                problemNumber={problem.number}
                user={user}
                refreshTrigger={impactRefreshTrigger}
              />
            </Col>
          </Row>
        </>
      )}

      {/* Generated by GitHub Copilot */}
      {outage &&
        outage.workflow_invocations &&
        outage.workflow_invocations.length > 0 && (
          <>
            <Row>
              <Col className="headings" xs={6} sm={6} md={6} lg={5} xl={5}>
                PD Workflow History
              </Col>
            </Row>
            <Row>
              <Col>
                <WorkflowHistoryViewer
                  workflowHistory={outage.workflow_invocations}
                />
              </Col>
            </Row>
          </>
        )}

      {problem && problem.number && outage && outage.number && (
        <Row>
          <Col>
            <PagerDutyActivity
              problemID={problem.number}
              outageID={outage.number}
              isActive={!(outage && outage.status && String(outage.status).toLowerCase() === "resolve")}
            />
          </Col>
        </Row>
      )}

      <Row>
        <Col className="headings" xs={6} sm={6} md={6} lg={5} xl={5}>
          Timeline
        </Col>
      </Row>
      {outage.notes ? (
        <>
          <Row>
            <Col>
              <Form.Label>Notes</Form.Label>
              <ModernViewer
                showEyeballs={false}
                showPIRs={true}
                notes={outage.notes}
                controls={false}
              />
            </Col>
          </Row>
        </>
      ) : (
        <></>
      )}

      <Row>
        <Col className="headings" xs={6} sm={6} md={6} lg={5} xl={5}>
          Communications
        </Col>
      </Row>
      {problem && <FormatComms communications={problem.communications} />}

      {/* Generated by GitHub Copilot */}
      {outage &&
        outage.interestedParties &&
        outage.interestedParties.length > 0 && (
          <>
            <Row>
              <Col className="headings" xs={6} sm={6} md={6} lg={5} xl={5}>
                Interested Parties
              </Col>
            </Row>
            <Row>
              <Col>
                <InterestedPartiesViewer
                  interestedParties={outage.interestedParties}
                />
              </Col>
            </Row>
          </>
        )}
    </>
  );
}

export default SinglePane;
